import React, { useState } from 'react';
import { useLeadSubmit } from '../../hooks/useLeadSubmit';
import { CONTACT_RESET_MS } from '../../constants/site';
import { ContactInfo } from './contact/ContactInfo';
import { ContactForm } from './contact/ContactForm';

const initialForm = { interest: 'general', name: '', phone: '', email: '', message: '', smsConsent: false };

export const ContactSection = ({ openPrivacyPolicy }) => {
  const [form, setForm] = useState(initialForm);
  const { submitted, submitting, submit } = useLeadSubmit({
    endpoint: '/leads/contact',
    errorLabel: 'contact lead',
    resetMs: CONTACT_RESET_MS,
    onSuccess: () => setForm(initialForm),
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    submit({ name: form.name, phone: form.phone, email: form.email, interest: form.interest, message: form.message, sms_consent: form.smsConsent });
  };

  return (
    <section id="contact" className="py-16 sm:py-24 bg-sand-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
          <div className="inline-block px-4 py-2 bg-sand-200 rounded-full"><span className="text-sm font-medium text-neutral-700">Get In Touch</span></div>
          <h2 className="text-4xl sm:text-5xl font-serif text-neutral-900">Let's Start Your Journey</h2>
          <p className="text-lg text-neutral-600">Ready to buy or sell? Have questions? I'm here to help. Reach out today and let's make your real estate dreams a reality.</p>
        </div>
        <div className="grid lg:grid-cols-2 gap-12">
          <ContactInfo />
          <ContactForm form={form} setForm={setForm} onSubmit={handleSubmit} submitted={submitted} submitting={submitting} openPrivacyPolicy={openPrivacyPolicy} />
        </div>
      </div>
    </section>
  );
};
